import axios from 'axios';

export const API_BASE_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth_token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiClient;
